/**
 * Extracts the campaign tag names from an offer's `offerCampaignTagsCollection`.
 * Replaces the deprecated string-array `tags` field on offers.
 */
export const getOfferCampaignTagNames = (offer: any): string[] =>
  offer?.offerCampaignTagsCollection?.items
    ?.map((tag: any) => tag?.tagName)
    ?.filter(Boolean) ?? [];

